import { AspectRatio } from "components/ui/aspect-ratio";
import Image from "next/image";
import { getFeatureImage } from "~/components/reusables/blog-card";
import { LinkTrackers } from "~/components/reusables/link-trackers";

export const ResourceCard = ({ item, dark = false }) => {
  const blogImage = item?.thumbnail
    ? item?.thumbnail?.url
    : item?.image?.url;
  const blogCategoryKey = item?.blog_category?.key;

  return (
    <>
      {item.fileType == "Blogs" ? (
        <LinkTrackers
          href={item.href}
          target={item.href.startsWith("/") ? "_self" : "_blank"}
          segmentMsg={
            item.href.startsWith(
              "https://outshift-headless-cms-s3.s3.us-east-2.amazonaws.com",
            )
              ? "Downloadable clicked"
              : "Resource clicked"
          }
          segmentOpt={{
            location: "resource section",
            link_label: item.title,
            location_detail: "body",
            resource_interaction: `visit the blog:  ${item.title}`,
          }}
          className="group col-span-1 md:col-span-3"
        >
          <div className="mx-auto aspect-[282/141] overflow-hidden rounded-xl">
            <div className={`${dark && "border border-white"}`}>
              <AspectRatio ratio={400 / 220}>
                <Image
                  unoptimized
                  src={blogImage || getFeatureImage(blogCategoryKey, item?.key)}
                  fill
                  alt="Featured home blog"
                  className="w-[90%] rounded-lg object-cover transition-all duration-700 group-hover:scale-105"
                  sizes="100%"
                />
              </AspectRatio>
            </div>
          </div>
          <div className="flex flex-col gap-1 p-3">
            <h6
              className={`font-tag pt-2 font-medium uppercase ${dark ? "text-white" : "text-[#06144D]"}`}
            >
              {item.fileType}
            </h6>
            <p className="font-p">
              {item.fileType == "eBooks" ? item.header : item.title}
            </p>
          </div>
        </LinkTrackers>
      ) : (
        <LinkTrackers
          href={item.href}
          target={item.href.startsWith("/") ? "_self" : "_blank"}
          segmentMsg={
            item.href.startsWith(
              "https://outshift-headless-cms-s3.s3.us-east-2.amazonaws.com",
            )
              ? "Downloadable clicked"
              : "Resource clicked"
          }
          segmentOpt={item.segmentOpt}
          className="group col-span-1 md:col-span-3"
        >
          <div className="mx-auto aspect-[282/141] overflow-hidden rounded-xl">
            <div className="">
              <AspectRatio ratio={400 / 220}>
                <Image
                  unoptimized
                  src={blogImage || getFeatureImage(blogCategoryKey, item?.key)}
                  fill
                  alt="Featured home blog"
                  className="w-[90%] rounded-lg object-cover transition-all duration-700 group-hover:scale-105"
                  sizes="100%"
                />
              </AspectRatio>
            </div>
          </div>
          <div className="flex flex-col gap-1 p-3">
            <h6
              className={`font-tag pt-2 font-medium uppercase ${dark ? "text-white" : "text-[#06144D]"}`}
            >
              {item.fileType}
            </h6>
            <p className="font-p">
              {item.fileType == "eBooks" ? item.header : item.title}
            </p>
          </div>
        </LinkTrackers>
      )}
    </>
  );
};
